/**
 * @file
 * Campiche behaviors.
 */
(function (Drupal) {
  "use strict";

  Drupal.behaviors.campiche = {
    attach(context, settings) {},
  };
})(Drupal);

import intro from "./intro.js";
import topbar from "./topbar.js";
import burger from "./burger.js";
import scrollingtext from "./scrollingtext.js";
import scrollto from "./scrollto.js";
import sidebarAnchors from "./sidebar-anchors.js";
import viewform from "./viewform.js";
import lightbox from "./lightbox.js";
import eventLightbox from "./event-lightbox.js";
import clipboard from "./clipboard.js";
import reviews from "./reviews.js";
import accordion from "./accordion.js";
import press from "./press.js";
import presentation from "./presentation.js";
import subscription from "./subscription.js";

intro.init();
topbar.init();
burger.init();
scrollingtext.init();
scrollto.init();
sidebarAnchors.init();
viewform.init();
lightbox.init();
eventLightbox.init();
clipboard.init();
reviews.init();
accordion.init();
press.init();
presentation.init();
subscription.init();
